import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PartnerWizardComponent } from '../cwc-partner-wizard';

/**
 * Definition of  parameters that the template needs to work.
 */
interface PartnerWizardButtonsModalTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: PartnerWizardComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const PartnerWizardButtonsModalTemplate: FunctionalComponent<PartnerWizardButtonsModalTemplateProps> = ({
  controller,
}) => (
  <div class={`root-buttons buttons-modal direction-${controller.buttonsDirection}`}>
    <div>
      <button
        onClick={async () => {
          await controller.setStep('channels');
          controller.onModalOpened.emit({
            type: 'self',
          });
        }}
        class={`button-${controller.buttonSelfVariant} button-modal-channels`}
        part={'button-self'}
      >
        {controller.textSelfButton}
      </button>

      {controller.textSelfButtonSubline && <div class="button-subline" innerHTML={controller.textSelfButtonSubline} />}
    </div>

    {controller.wizardData.tradingPartners.length > 0 ? (
      <div>
        <button
          onClick={async () => {
            await controller.setStep('partners');
            controller.onModalOpened.emit({
              type: 'partners',
            });
          }}
          class={`button-${controller.buttonPartnersVariant} button-modal-partners`}
          part={'button-partners'}
        >
          {controller.textPartnersButton}
        </button>

        {controller.textPartnersButtonSubline && (
          <div class="button-subline" innerHTML={controller.textPartnersButtonSubline} />
        )}
      </div>
    ) : (
      ''
    )}
  </div>
);

export default PartnerWizardButtonsModalTemplate;
